import React, { useState, memo, useRef } from 'react';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import { toast } from 'react-toastify';
import { ValidatePassword } from '../../utils';
import { ResetPassword, Recaptchahandler } from '../../api/endpoints'
import Field from '../../component/formFields/InputField';
import ReCAPTCHA from 'react-google-recaptcha';
import AuthWrapper from './components/authWrapper';

const recaptchaSiteKey = import.meta.env.VITE_RECAPTCHA_SITEKEY

const ResetPass = () => {
    const [password, setPassword] = useState('')
    const [confirmPassword, setconfirmPassword] = useState('')
    const [loading, setLoading] = useState(false)
    const { t, i18n } = useTranslation()
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const captchaRef = useRef(null);
    const [isHuman, setIsHuman] = useState(false);

    const recaptchahandler = () => {
        const RecaptchaData = {
            token: captchaRef.current.getValue(),
        }

        Recaptchahandler(RecaptchaData).then(res => {
            setIsHuman(res.data)
        })
    }

    const resetPassword = (e) => {
        e?.preventDefault()

        if (!ValidatePassword(password)) {
            toast.error(t("wrong-password"))
            return
        }

        if (password !== confirmPassword) {
            toast.error(t("password not matched"))
            return
        }

        var ResetPasswordData = {
            code: searchParams.get("code"),
            password: password
        }

        setLoading(true)
        ResetPassword(ResetPasswordData).then(result => {
            setLoading(false)
            if (result.data.success)
                navigate('/login', { state: { verifyMessage: "Password updated successfully" } })

        }).catch(() => {
            setLoading(false)
        })
    }

    return (

        <AuthWrapper>
            <div className='input-container'>
                <Field type="password" name="password" value={password} setValue={setPassword} label={t("password")} placeholder={t("password")} />
            </div>

            <div className='input-container'>
                <Field type="password" name="confirmPassword" value={confirmPassword} setValue={setconfirmPassword} label={t("confirmNewPassword")} placeholder={t("confirmNewPassword")} />
            </div>

            <div className='recaptcha-container'>
                <ReCAPTCHA className='recaptcha' sitekey={recaptchaSiteKey} ref={captchaRef} onChange={recaptchahandler} />
            </div>

            <button className="login-btn" onClick={resetPassword} disabled={loading || !isHuman}>
                <span className={loading ? "spinner-border spinner-border-sm" : ""} role="status" aria-hidden="true"></span>
                {t("confirm")}
            </button>
            <div className='donot-have-account-container'>
                {t("backTo")} <Link to='/'>{t("login")}</Link>

            </div>
        </AuthWrapper>

    );
}

export default memo(ResetPass);

